import { ReactNode } from 'react';
import { BookType } from '../types';

export interface BookTypeConfig {
  icon: (className?: string) => ReactNode;
  descriptionKey: string;
}

// SVG path data for each book type (reusable without class names)
const BOOK_TYPE_PATHS = {
  fiction:
    'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
  non_fiction:
    'M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z',
};

// Create icon function for each book type
const createBookTypeIcon = (type: BookType) => {
  const IconComponent = ({ className = 'w-5 h-5' }: { className?: string }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d={BOOK_TYPE_PATHS[type]}
      />
    </svg>
  );
  IconComponent.displayName = `BookTypeIcon_${type}`;

  const IconWrapper = (className = 'w-5 h-5') => <IconComponent className={className} />;
  IconWrapper.displayName = `BookTypeIconWrapper_${type}`;
  return IconWrapper;
};

export const BOOK_TYPE_CONFIG: Record<BookType, BookTypeConfig> = {
  fiction: {
    icon: createBookTypeIcon('fiction'),
    descriptionKey: 'bookTypeDescriptions.fiction',
  },
  non_fiction: {
    icon: createBookTypeIcon('non_fiction'),
    descriptionKey: 'bookTypeDescriptions.non_fiction',
  },
};

// Helper to get icon with specific size
export const getBookTypeIcon = (type: BookType, className = 'w-5 h-5'): ReactNode => {
  return BOOK_TYPE_CONFIG[type].icon(className);
};

// All book types as array for iteration
export const BOOK_TYPES: BookType[] = ['fiction', 'non_fiction'];
